/**
 *  @class
 *  @function EsArtTypes
 */

class EsArtTypes extends HTMLElement {
	constructor() {
		super();
	}
	
	connectedCallback() {
    this.customOptions();
	}

  customOptions() {
    let _this = this;
    const options = _this.querySelectorAll('.custom-option');

    options?.forEach(option => {
      option.addEventListener('click', function () {
        const primaryImage = this.dataset.primaryImage;
        const secondaryImage = this.dataset.secondaryImage;
        const href = this.dataset.href;
        const productCard = _this.closest('.product-card');
        const primaryImageSrcset = primaryImage + " 770w";
        const secondaryImageSrcset = secondaryImage + " 770w";
        const selectedOtherOptions = productCard.querySelectorAll('.custom-option.is-selected');

        selectedOtherOptions?.forEach((option) => {
          console.log(option);
        })

        const scriptTag = productCard.querySelector('script[type="application/json"]');
        const jsonData = JSON.parse(scriptTag.textContent);

        console.log(jsonData);

        productCard.querySelector('.product-secondary-image').setAttribute('src', secondaryImage);
        productCard.querySelector('.product-secondary-image').setAttribute('srcset', secondaryImageSrcset);
        productCard.querySelector('.product-primary-image').setAttribute('src', primaryImage);
        productCard.querySelector('.product-primary-image').setAttribute('srcset', primaryImageSrcset);
        productCard.querySelector('.product-featured-image-link').setAttribute('href', href);

        // this.closest('.es-art-types').querySelectorAll('.custom-option')?.forEach((el) => {
        //   el.classList.remove('is-selected');
        // });

        // this.classList.add('is-selected');
      })
    })
  }
}

customElements.define('es-art-types', EsArtTypes);
